import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ShopifyAdminLayout from './shopify-admin/ShopifyAdminLayout';

// Import all shopify admin pages
import ShopifyAdminIndex from './shopify-admin/index';
import ShopifyProfilePage from './shopify-admin/profile/index';
import ProductsPage from './shopify-admin/products/index';
import OrdersPage from './shopify-admin/orders/index';
import CustomersPage from './shopify-admin/customers/index';
import CrmTagsPage from './shopify-admin/crm-tags/index';

const ShopifyAdmin: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ShopifyAdminLayout />}>
        <Route index element={<ShopifyAdminIndex />} />
        <Route path="profile" element={<ShopifyProfilePage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="crm-tags" element={<CrmTagsPage />} />
      </Route>
    </Routes>
  );
};

export default ShopifyAdmin;
